import { ProcessedInputSchema, ResponseSchema, ValuesSchema } from 'Lib/schemas';

export const leverSchema = new ProcessedInputSchema((value) => ({
  pid: value.pid || value.pId || value.p_id,
  type: typeof value.value,
  value: value.value,
}));

export const leversSchema = new ValuesSchema(leverSchema);

export const metaResponseSchema = new ResponseSchema(
  {
    levers: leversSchema,
  },
  {
    processResult: {
      ageVerificationStatus: ['ageVerification', 'status'],
      ageVerificationReason: ['ageVerification', 'reason'],
      ageVerificationShowSessionOnboardingModal: ['ageVerification', 'showSessionOnboardingModal'],
      ageVerificationIsSessionOnboardingSkippable: [
        'ageVerification',
        'isSessionOnboardingSkippable',
      ],
      biometricConsents: ['biometricConsent', 'consents'],
      biometricLivenessState: ['biometricLiveness', 'state'],
      consent: ['account', 'consents'],
      // canAddPhotosFromFacebook: ['profile', 'canAddPhotosFromFacebook'],
      canEditEmail: ['profile', 'canEditEmail'],
      // canEditJobs: ['profile', 'canEditJobs'],
      // canEditSchools: ['profile', 'canEditSchools'],
      companyMaxLength: ['profile', 'companyNameMaxLength'],
      chatSuggestionConsents: ['chatSuggestionConsent', 'consents'],
      emailVerificationRequired: ['account', 'emailPromptRequired'],
      emailVerificationDismissible: ['account', 'emailPromptDismissible'],
      globalPassportTitle: ['passport', 'globalModalTitleText'],
      globalPassportDescription: ['passport', 'globalModalDescriptionText'],
      isBiometricConsentNeeded: ['biometricConsent', 'needsConsent'],
      isMessageConsentNeeded: ['messageConsent', 'needsConsent'],
      isTermsAcceptanceNeeded: ['termsOfService', 'needsAccept'],
      jobTitleMaxLength: ['profile', 'jobTitleMaxLength'],
      levers: ['levers'],
      merchandisingFeatures: ['clientResources', 'plusScreen'],
      messageConsents: ['messageConsent', 'consents'],
      orientations: ['sexualOrientations', 'orientations'],
      orientationEnabled: ['sexualOrientations', 'enabled'],
      paywallFeatures: ['clientResources', 'rateCard', 'carousel'],
      platinumPaywallFeatures: ['clientResources', 'platinumPaywallCarousel'],
      schoolMaxLength: ['profile', 'schoolNameMaxLength'],
      showTerms: ['termsOfService', 'enabled'],
      superlikeAlcMode: ['superLike', 'alcMode'],
      superBoostMembersText: ['superBoost', 'membersOnlyText'],
      typingPulseInterval: ['typingIndicator', 'typingHeartbeat'],
      typingTimeout: ['typingIndicator', 'typingTtl'],
      termsVersion: ['termsOfService', 'version'],
    },
  }
);

export const bucketsResponseSchema = new ResponseSchema(
  {
    levers: leversSchema,
  },
  {
    processResult: {
      levers: ['levers'],
    },
  }
);
